import React from 'react';
import "react-router-dom";

import Player from '../functions/player';

import { EntitiesArray } from '../components/island';
import { powerPlants } from '../actions/powerPlantsArray';
import { Timer } from './timer';


import API from '../functions/api';

export class GameInfo extends React.Component {
  constructor(props) {
    super(props);

		this.state = {
      deadline: '21 Mar 2018 10:00:00',
      mwuPrice: 1,
      mwuNecessity: 0,
      currentRound: 1,
      updateSliders: false,
    };

    this.nextRound = this.nextRound.bind(this);
    this.instantUpdate = this.instantUpdate.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.updateSliders !== this.state.updateSliders) {
      this.setState({ updateSliders: nextProps.updateSliders });
      this.setSliders();
    }
  }

  setSliders = () => {
    let mwuNecessity = 0;
    for (var i = 0; i < EntitiesArray.length; i++) {
      let data = EntitiesArray[i];
      mwuNecessity += data.getMwuNecessity()
    }

    let totalMwu = EntitiesArray.reduce( (total, current) => {return total + (["city", "company"].includes(current.type) ? parseFloat(current.getMwuServices(), 10) : 0)}, 0 );
    let percentageSupplied = totalMwu / mwuNecessity * 100;

    let totalProduced = powerPlants.reduce( (total, current) => { return total + (current.purchasedBy !== false && current.demolished === false ? current.mwu : 0) }, 0 );
    let totalProducedGreen = powerPlants.reduce( (total, current) => { return total + (current.purchasedBy !== false && current.demolished === false && current.green ? current.mwu : 0) }, 0 );

    const totalGreen = (totalProducedGreen / totalProduced) * 100;

    if (percentageSupplied > 100) {
      percentageSupplied = 100;
    }

    this.setState({
			mwuNecessity: mwuNecessity,
      percentageSupplied: percentageSupplied,
      totalGreen: totalGreen,
		});
  }

	componentWillMount() {
    let time = Player.getData('gameTime');
    if (time === undefined || null) {
      time = [80,  2, 14, 4, 12, 2, 3, 3, 12, 2, 3, 3, 12, 8];
    }

    var currentTime = new Date();
    currentTime.setMinutes(currentTime.getMinutes() + time[this.props.part]);

    this.setState({
      deadline: currentTime,
    });

	  this.setSliders();
  }

  nextRound() {
    this.refs.Timer.endRound();
  }

  instantUpdate() {
    this.refs.Timer.instantUpdate();
  }

  componentDidMount() {
    let getRound = Player.getData('round');

    if (isNaN(getRound)) {
      this.setState({
        currentRound: 1,
      });
      Player.storeData('round', this.state.currentRound);

    } else {
      this.setState({
  			currentRound: getRound,
  		});
      //console.log('Current round: ' + getRound);
    }

    // Set the price for one MWU in that round
    let round = Player.getData('round');
    let mwuPrice = 45 + (5 * round);

    this.setState({
      mwuPrice: mwuPrice,
    });
  }

  restoreFromSession() {
    // Check if cookie isset
    let cookie = Player.getCookie('sessionID');
    if (cookie) {
      API.post('/?action=getSession&code=' + encodeURIComponent(cookie) )
      .then((response) => {
        //console.log(response);
        //this.state.time = response.data.elapsedTime;
        Player.storeData('timeLeft', response.data.elapsedTime);

      })
      .catch(function (error) {
        console.log(error);
      });
    }
  }

  render() {
    if(this.props.game === "true"){
      return(
        <div className={(this.props.game === "true" ? "gameInfo game" : "gameInfo")}>
          <div className="gameData">
            <div className="gradientWrap">
              <div className="sliderBar necessity">
                <div className="text">Elektriciteitsvoorziening</div>
                <div className="bar">
                  <div className="slider" style={{left: this.state.percentageSupplied + "%"}}></div>
                  <div className="gradient"></div>
                </div>
                <div className="number tall">
                  <span>
                    {this.state.percentageSupplied.toFixed(0)}%
                  </span>
                </div>
              </div>
              <div className="sliderBar renewable">
                <div className="text">Duurzaamheid</div>
                <div className="bar">
                  <div className="slider" style={{left: this.state.totalGreen + "%"}}></div>
                  <div className="gradient"></div>
                </div>
                <div className="number tall">
                  <span>
                    {this.state.totalGreen.toFixed(0)}%
                  </span>
                </div>
              </div>
            </div>
            <div className="price">
              <div className="text">
                Huidige prijs elektriciteit (&euro;)
              </div>
              <div className="number">
                <span>
                  {this.state.mwuPrice}
                </span>
              </div>
            </div>
          </div>
          <div className="time">
            <div className="text">
              Ronde {this.state.currentRound} / Resterende tijd
            </div>
            <div className="timeWrap">
              <Timer viewActions={true} ref="Timer" deadline={ this.state.deadline } getGameScreen={this.props.getGameScreen} part={this.props.part} />
            </div>
          </div>
        </div>
      );
    } else {
      return(
        <div className="gameInfo">
          <div className="gameData">
            <h4> Elektriciteitsbehoefte (MWU) <span>{this.state.mwuNecessity}</span></h4>
          </div>
          <div className="gameData">
            <h4> Huidige prijs elektriciteit (€) <span>{this.state.mwuPrice}</span></h4>
          </div>
          <div className="gameData">
            <h4> This is round {this.state.currentRound}</h4>
          </div>
          <Timer viewActions={false} ref="Timer" deadline={ this.state.deadline } getGameScreen={this.props.getGameScreen} part={this.props.part} />
        </div>
      )
    }

  }

}



// WEBPACK FOOTER //
// ./src/components/gameInfo.js